/* eslint-disable react/prop-types */

import { useTheme } from 'styled-components';
import { colors } from 'utils/colors';

export const CHEVRON_SVG = ({
  disabled = false,
  isRight = false,
  color = colors.gray950,
  size = 32,
  onClick,
  styles,
}) => (
  <svg
    onClick={disabled ? null : onClick}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: `rotate(${isRight ? '180' : '0'}deg)`,
      cursor: 'pointer',
      ...styles,
    }}
  >
    <path
      d="M20 24L12 16L20 8"
      stroke={disabled ? colors.gray100 : color}
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SMILEYS_SVG = ({ color = '#090A14' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5714 2H4.85714C3.27619 2 2 3.27619 2 4.85714V10.5714C2 12.1524 3.27619 13.4286 4.85714 13.4286H9.14286C9.14286 11.0667 11.0667 9.14286 13.4286 9.14286V4.85714C13.4286 3.27619 12.1524 2 10.5714 2ZM4.6381 5.11429C5.37143 4.59048 6.37143 4.58095 7.12381 5.09524C7.44762 5.31429 7.53333 5.7619 7.31429 6.08571C7.09524 6.40952 6.64762 6.49524 6.32381 6.27619C6.06667 6.09524 5.71429 6.09524 5.45714 6.28571C5.33333 6.37143 5.19048 6.40952 5.04762 6.40952C4.82857 6.40952 4.6 6.30476 4.46667 6.11429C4.2381 5.79048 4.31429 5.34286 4.6381 5.11429ZM9.87619 8.89524C9.62857 9.20952 9.18095 9.25714 8.87619 9.00952C8.54286 8.74286 8.14286 8.6 7.71429 8.6C6.7619 8.6 5.97143 9.32381 5.86667 10.2571H7.86667C8.25714 10.2571 8.58095 10.581 8.58095 10.9714C8.58095 11.3619 8.25714 11.6857 7.86667 11.6857H5.65714C4.98095 11.6857 4.42857 11.1333 4.42857 10.4571C4.42857 8.64762 5.90476 7.17143 7.71429 7.17143C8.45714 7.17143 9.19048 7.42857 9.77143 7.89524C10.0762 8.14286 10.1238 8.59048 9.87619 8.89524ZM11.1238 6.08571C10.9048 6.40952 10.4571 6.49524 10.1333 6.27619C9.87619 6.09524 9.52381 6.09524 9.26667 6.28571C9.14286 6.37143 9 6.40952 8.85714 6.40952C8.63809 6.40952 8.40952 6.30476 8.27619 6.11429C8.04762 5.79048 8.12381 5.34286 8.44762 5.11429C9.18095 4.59048 10.181 4.58095 10.9333 5.09524C11.2571 5.31429 11.3429 5.7619 11.1238 6.08571ZM18.4 16.9334C18.3333 16.8572 18.2381 16.8191 18.1333 16.8191H14.4381C14.3333 16.8191 14.2381 16.8572 14.1714 16.9334C14.1048 17.0096 14.0667 17.1143 14.0857 17.2096C14.2095 18.3334 15.1524 19.1905 16.2857 19.1905C17.419 19.1905 18.3619 18.3429 18.4857 17.2096C18.4952 17.1048 18.4667 17.0096 18.4 16.9334ZM13.4286 10.5714H19.1429C20.7143 10.5714 22 11.8571 22 13.4286V19.1429C22 20.7143 20.7143 22 19.1429 22H13.4286C11.8571 22 10.5714 20.7143 10.5714 19.1429V13.4286C10.5714 11.8571 11.8571 10.5714 13.4286 10.5714ZM14.0381 13.419C13.7143 13.1905 13.2667 13.2667 13.0381 13.5905C12.8095 13.9048 12.8857 14.3524 13.2095 14.5905C13.581 14.8571 14.019 14.9905 14.4667 14.9905C14.8952 14.9905 15.3238 14.8571 15.6952 14.6095C16.0286 14.3905 16.1048 13.9429 15.8857 13.619C15.6667 13.2857 15.219 13.2 14.8952 13.4286C14.6381 13.6 14.2952 13.6 14.0381 13.419ZM13 16.9714C13 18.781 14.4762 20.2571 16.2857 20.2571C18.0952 20.2571 19.5714 18.781 19.5714 16.9714C19.5714 16.2952 19.019 15.7429 18.3429 15.7429H14.2286C13.5524 15.7429 13 16.2952 13 16.9714ZM18.2762 14.981C18.7048 14.981 19.1333 14.8476 19.5048 14.6C19.8286 14.381 19.9143 13.9429 19.6952 13.6095C19.4762 13.2762 19.0286 13.1905 18.7048 13.419C18.4476 13.5905 18.1048 13.5905 17.8476 13.4095C17.5238 13.181 17.0762 13.2571 16.8476 13.581C16.619 13.9048 16.6952 14.3524 17.019 14.581C17.3905 14.8476 17.8286 14.981 18.2762 14.981Z"
      fill={color}
    />
  </svg>
);

export const CARD_TICK_SVG = ({ color = '#090A14' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.03 2H19.97C21.24 2 22 2.76 22 4.03V6.97C22 8.24 21.24 9 19.97 9H17.03C15.76 9 15 8.24 15 6.97V4.03C15 2.76 15.76 2 17.03 2ZM18.26 7.22L20.63 4.45C20.81 4.24 20.79 3.91 20.56 3.73C20.34 3.55 20.02 3.57 19.83 3.79L17.83 6.13L17.13 5.44C16.93 5.23 16.6 5.24 16.4 5.44C16.2 5.64 16.2 5.97 16.4 6.17L17.5 7.25C17.6 7.35 17.73 7.4 17.87 7.4H17.89C18.03 7.4 18.17 7.33 18.26 7.22ZM13.5 4.6099V7.5399C13.5 8.2099 12.96 8.7499 12.29 8.7499H3.21C2.53 8.7499 2 8.1899 2 7.5199C2.01 6.3899 2.46 5.3599 3.21 4.6099C3.96 3.8599 5 3.3999 6.14 3.3999H12.29C12.96 3.3999 13.5 3.9399 13.5 4.6099ZM2 11.46V16.46C2 18.75 3.85 20.6 6.14 20.6H17.85C20.14 20.6 22 18.74 22 16.45V11.46C22 10.79 21.46 10.25 20.79 10.25H3.21C2.54 10.25 2 10.79 2 11.46ZM8 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25ZM14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z"
      fill={color}
    />
  </svg>
);

export const SEND_SQUARE_SVG = ({ color = '#090A14' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM8.64 12.81L13.02 8.43H10.59C10.18 8.43 9.84 8.09 9.84 7.68C9.84 7.27 10.18 6.93 10.59 6.93H14.83C14.93 6.93 15.02 6.95 15.12 6.99C15.3 7.07 15.45 7.21 15.53 7.4C15.57 7.49 15.59 7.59 15.59 7.69V11.93C15.59 12.34 15.25 12.68 14.84 12.68C14.43 12.68 14.09 12.34 14.09 11.93V9.5L9.7 13.87C9.55 14.02 9.36 14.09 9.17 14.09C8.98 14.09 8.79 14.02 8.64 13.87C8.35 13.58 8.35 13.1 8.64 12.81ZM18.24 17.22C16.23 17.89 14.12 18.23 12 18.23C9.88 18.23 7.77 17.89 5.76 17.22C5.37 17.09 5.16 16.66 5.29 16.27C5.42 15.88 5.84 15.66 6.24 15.8C9.96 17.04 14.05 17.04 17.77 15.8C18.16 15.67 18.59 15.88 18.72 16.27C18.84 16.67 18.63 17.09 18.24 17.22Z"
      fill={color}
    />
  </svg>
);

export const CALENDAR_EDIT_SVG = ({ color = '#090A14' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.75 2V3.56C19.45 3.81 20.76 5.42 20.96 7.81C20.99 8.09 20.75 8.34 20.46 8.34H3.54C3.26 8.34 3.02 8.1 3.04 7.81C3.24 5.42 4.55 3.81 7.25 3.56V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V3.5H15.25V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2ZM4 9.84009H20C20.55 9.84009 21 10.2901 21 10.8401V17.0001C21 20.0001 19.5 22.0001 16 22.0001H8C4.5 22.0001 3 20.0001 3 17.0001V10.8401C3 10.2901 3.45 9.84009 4 9.84009ZM14.34 15.5001L14.84 14.9901C15.45 14.3801 15.74 13.6701 14.84 12.7701C14.43 12.3601 14.06 12.2001 13.72 12.2001C13.32 12.2001 12.95 12.4401 12.62 12.7701L12.12 13.2801L9.08 16.3101C8.95 16.4501 8.82 16.7101 8.79 16.9001L8.6 18.2601C8.53 18.7401 8.87 19.0901 9.36 19.0201L10.71 18.8201C10.9 18.8001 11.17 18.6601 11.3 18.5301L14.33 15.5001H14.34Z"
      fill={color}
    />
  </svg>
);

export const GALLERY_SVG = ({ color = '#090A14' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.58005 19.01L2.56005 19.03C2.29005 18.44 2.12005 17.77 2.05005 17.03C2.12005 17.76 2.31005 18.42 2.58005 19.01Z"
      fill={color}
    />
    <path
      d="M9.00012 10.3801C10.3146 10.3801 11.3801 9.31456 11.3801 8.00012C11.3801 6.68568 10.3146 5.62012 9.00012 5.62012C7.68568 5.62012 6.62012 6.68568 6.62012 8.00012C6.62012 9.31456 7.68568 10.3801 9.00012 10.3801Z"
      fill={color}
    />
    <path
      d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 17.28 2.19 18.23 2.56 19.03C3.42 20.93 5.26 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V13.9V7.81C22 4.17 19.83 2 16.19 2ZM20.37 12.5C19.59 11.83 18.33 11.83 17.55 12.5L13.39 16.07C12.61 16.74 11.35 16.74 10.57 16.07L10.23 15.79C9.52 15.17 8.39 15.11 7.59 15.65L3.85 18.16C3.63 17.6 3.5 16.95 3.5 16.19V7.81C3.5 4.99 4.99 3.5 7.81 3.5H16.19C19.01 3.5 20.5 4.99 20.5 7.81V12.61L20.37 12.5Z"
      fill={color}
    />
  </svg>
);

export const PROFILE_SVG = ({ color = '#090A14' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
      fill={color}
    />
    <path
      d="M17.08 14.1499C14.29 12.2899 9.73996 12.2899 6.92996 14.1499C5.65996 14.9999 4.95996 16.1499 4.95996 17.3799C4.95996 18.6099 5.65996 19.7499 6.91996 20.5899C8.31996 21.5299 10.16 21.9999 12 21.9999C13.84 21.9999 15.68 21.5299 17.08 20.5899C18.34 19.7399 19.04 18.5999 19.04 17.3599C19.03 16.1299 18.34 14.9899 17.08 14.1499Z"
      fill={color}
    />
  </svg>
);

export const CALENDAR_SVG = ({ size = 24, color = '#090A14', onClick }) => (
  <svg
    onClick={onClick}
    width={size}
    height={size}
    style={{ cursor: 'pointer' }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.55 2.72289V4.2265C19.25 4.46746 20.56 6.01926 20.76 8.32286C20.79 8.59274 20.55 8.83371 20.26 8.83371H3.34003C3.06003 8.83371 2.82003 8.60238 2.84003 8.32286C3.04003 6.01926 4.35003 4.46746 7.05003 4.2265V2.72289C7.05003 2.32771 7.39003 2 7.80003 2C8.21003 2 8.55003 2.32771 8.55003 2.72289V4.16867H15.05V2.72289C15.05 2.32771 15.39 2 15.8 2C16.21 2 16.55 2.32771 16.55 2.72289ZM3.80005 10.2796H19.8C20.35 10.2796 20.8 10.7133 20.8 11.2434V17.1807C20.8 20.0723 19.3 22 15.8 22H7.80005C4.30005 22 2.80005 20.0723 2.80005 17.1807V11.2434C2.80005 10.7133 3.25005 10.2796 3.80005 10.2796ZM8.96005 18.3877C8.97672 18.3738 8.99338 18.3599 9.01005 18.347C9.19005 18.1639 9.30005 17.9133 9.30005 17.6627C9.30005 17.4121 9.19005 17.1615 9.01005 16.9783L8.86005 16.8627C8.80005 16.8241 8.74005 16.7952 8.68005 16.7759C8.62005 16.747 8.56005 16.7277 8.50005 16.7181C8.30005 16.6795 8.10005 16.6988 7.92005 16.7759C7.79005 16.8241 7.69005 16.8916 7.59005 16.9783C7.41005 17.1615 7.30005 17.4121 7.30005 17.6627C7.30005 17.9133 7.41005 18.1639 7.59005 18.347C7.69005 18.4337 7.79005 18.5012 7.92005 18.5494C8.04005 18.5976 8.17005 18.6265 8.30005 18.6265C8.36217 18.6265 8.41642 18.6189 8.47677 18.6105C8.48442 18.6094 8.49217 18.6083 8.50005 18.6072C8.56005 18.5976 8.62005 18.5783 8.68005 18.5494C8.74005 18.5301 8.80005 18.5012 8.86005 18.4627C8.89338 18.4434 8.92672 18.4155 8.96005 18.3877ZM8.30005 15.253C8.56005 15.253 8.82005 15.147 9.01005 14.9735C9.19005 14.7904 9.30005 14.5398 9.30005 14.2892C9.30005 14.0386 9.19005 13.788 9.01005 13.6049C8.92005 13.5181 8.81005 13.4506 8.68005 13.4024C8.31005 13.2482 7.87005 13.335 7.59005 13.6049C7.41005 13.788 7.30005 14.0386 7.30005 14.2892C7.30005 14.5398 7.41005 14.7904 7.59005 14.9735C7.78005 15.147 8.04005 15.253 8.30005 15.253ZM11.8 18.6265C12.06 18.6265 12.32 18.5205 12.51 18.347C12.69 18.1639 12.8 17.9133 12.8 17.6627C12.8 17.4121 12.69 17.1615 12.51 16.9783C12.14 16.6217 11.46 16.6217 11.09 16.9783C10.91 17.1615 10.8 17.4121 10.8 17.6627C10.8 17.9133 10.91 18.1639 11.09 18.347C11.28 18.5205 11.54 18.6265 11.8 18.6265ZM12.36 15.0892L12.51 14.9735C12.69 14.7904 12.8 14.5398 12.8 14.2892C12.8 14.0386 12.69 13.788 12.51 13.6049C12.23 13.335 11.79 13.2482 11.42 13.4024C11.29 13.4506 11.18 13.5181 11.09 13.6049C10.91 13.788 10.8 14.0386 10.8 14.2892C10.8 14.5398 10.91 14.7904 11.09 14.9735C11.28 15.147 11.54 15.253 11.8 15.253C11.8622 15.253 11.9164 15.2454 11.9768 15.237C11.9844 15.2359 11.9922 15.2348 12 15.2338C12.06 15.2241 12.12 15.2048 12.18 15.1759C12.24 15.1567 12.3 15.1277 12.36 15.0892ZM15.3 18.6265C15.56 18.6265 15.82 18.5205 16.01 18.347C16.19 18.1639 16.3 17.9133 16.3 17.6627C16.3 17.4121 16.19 17.1615 16.01 16.9783C15.64 16.6217 14.96 16.6217 14.59 16.9783C14.41 17.1615 14.3 17.4121 14.3 17.6627C14.3 17.9133 14.41 18.1639 14.59 18.347C14.78 18.5205 15.04 18.6265 15.3 18.6265ZM15.86 15.0892L16.01 14.9735C16.19 14.7904 16.3 14.5398 16.3 14.2892C16.3 14.0386 16.19 13.788 16.01 13.6049L15.86 13.4892C15.8 13.4506 15.74 13.4217 15.68 13.4024C15.62 13.3735 15.56 13.3543 15.5 13.3446C15.3 13.3061 15.1 13.3253 14.92 13.4024C14.79 13.4506 14.69 13.5181 14.59 13.6049C14.41 13.788 14.3 14.0386 14.3 14.2892C14.3 14.5398 14.41 14.7904 14.59 14.9735C14.78 15.147 15.04 15.253 15.3 15.253C15.36 15.253 15.43 15.2434 15.5 15.2338C15.56 15.2241 15.62 15.2048 15.68 15.1759C15.74 15.1567 15.8 15.1277 15.86 15.0892Z"
      fill={color}
    />
  </svg>
);

export const PLUS_SVG = ({ size = '24px', color = '#090A14' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1612 1.1612C13.1612 0.519839 12.6413 -8.89301e-05 11.9999 -8.89301e-05C11.3585 -8.89301e-05 10.8386 0.519839 10.8386 1.1612V10.8386H1.16118C0.519819 10.8386 -0.000108685 11.3585 -0.000108719 11.9999C-0.000108753 12.6413 0.519819 13.1612 1.16118 13.1612H10.8386V22.8386C10.8386 23.48 11.3585 23.9999 11.9999 23.9999C12.6413 23.9999 13.1612 23.48 13.1612 22.8386V13.1612H22.8386C23.48 13.1612 23.9999 12.6413 23.9999 11.9999C23.9999 11.3586 23.48 10.8386 22.8386 10.8386H13.1612V1.1612Z"
      fill={color}
    />
  </svg>
);

export const STAR_SVG = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.01378 2.36827C7.45405 1.58091 8.54606 1.58091 8.98633 2.36827L10.2068 4.55095C10.3681 4.83938 10.6383 5.0439 10.9515 5.11454L13.3215 5.64913C14.1765 5.84197 14.5139 6.92377 13.9311 7.60323L12.3154 9.48679C12.1019 9.73569 11.9986 10.0666 12.0309 10.3987L12.2752 12.9118C12.3633 13.8183 11.4798 14.4869 10.6794 14.1195L8.46031 13.1009C8.16708 12.9663 7.83303 12.9663 7.5398 13.1009L5.32074 14.1195C4.52026 14.4869 3.63681 13.8183 3.72493 12.9118L3.9692 10.3987C4.00148 10.0666 3.89826 9.73569 3.68475 9.48679L2.06902 7.60323C1.48618 6.92377 1.82362 5.84197 2.67857 5.64913L5.04859 5.11454C5.36178 5.0439 5.63203 4.83938 5.7933 4.55095L7.01378 2.36827Z"
      fill="#FBB121"
    />
  </svg>
);

export const HEART_SVG = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.61367 14.1017C8.025 14.3427 7.32509 14.2222 6.84766 13.7402L2.1092 8.95663L2.10923 8.9566C0.482468 7.31434 0.482471 4.65171 2.10924 3.00945C3.736 1.36718 6.37351 1.36718 8.00028 3.00944C9.62705 1.3672 12.2645 1.36721 13.8913 3.00947C15.5181 4.65172 15.5181 7.31434 13.8913 8.9566L13.8913 8.95661L13.8913 8.95663L9.15289 13.7402L9.15285 13.7402C9.14198 13.7512 9.13099 13.762 9.11989 13.7726"
      fill="#D84B4B"
    />
  </svg>
);
export const ARCHIVE_SVG = ({ color = '#676770' }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.3335 12.1875H10.3335C9.471 12.1875 8.771 12.8875 8.771 13.75V15.0625C8.8085 15.05 8.8335 15.0375 8.871 15.025C9.021 14.95 9.1835 14.9 9.346 14.85C9.421 14.825 9.496 14.8 9.5835 14.775C9.8335 14.725 10.0835 14.6875 10.346 14.6875H20.346C20.6085 14.6875 20.8585 14.725 21.1085 14.775C21.1835 14.7875 21.2585 14.825 21.346 14.85C21.5085 14.9 21.671 14.95 21.821 15.025C21.8585 15.0375 21.896 15.05 21.921 15.0625V13.75C21.896 12.8875 21.196 12.1875 20.3335 12.1875Z"
      fill={color}
    />
    <path
      d="M20.3335 16.5625H10.3335C9.471 16.5625 8.771 17.2625 8.771 18.125V18.75H12.2085C12.721 18.75 13.146 19.175 13.146 19.6875C13.146 20.8875 14.1335 21.875 15.3335 21.875C16.5335 21.875 17.521 20.8875 17.521 19.6875C17.521 19.175 17.946 18.75 18.4585 18.75H21.896V18.125C21.896 17.2625 21.196 16.5625 20.3335 16.5625Z"
      fill={color}
    />
    <path
      d="M20.3335 8.125H10.3335C9.471 8.125 8.771 8.825 8.771 9.6875V10.7C9.246 10.4625 9.771 10.3125 10.3335 10.3125H20.3335C20.896 10.3125 21.421 10.4625 21.896 10.7V9.6875C21.896 8.825 21.196 8.125 20.3335 8.125Z"
      fill={color}
    />
    <path
      d="M20.571 2.5H10.096C5.546 2.5 2.8335 5.2125 2.8335 9.7625V20.225C2.8335 24.7875 5.546 27.5 10.096 27.5H20.5585C25.1085 27.5 27.821 24.7875 27.821 20.2375V9.7625C27.8335 5.2125 25.121 2.5 20.571 2.5ZM24.0835 20.625H22.8335H19.2835C18.8585 22.4125 17.246 23.75 15.3335 23.75C13.421 23.75 11.8085 22.4125 11.3835 20.625H7.8335H6.5835C6.071 20.625 5.646 20.2 5.646 19.6875C5.646 19.175 6.071 18.75 6.5835 18.75H6.896V18.125V17.5V13.75V9.6875C6.896 7.7875 8.4335 6.25 10.3335 6.25H20.3335C22.2335 6.25 23.771 7.7875 23.771 9.6875V13.75V17.5V18.125V18.75H24.0835C24.596 18.75 25.021 19.175 25.021 19.6875C25.021 20.2 24.596 20.625 24.0835 20.625Z"
      fill={color}
    />
  </svg>
);

export const PAYMENT_SVG = () => (
  <svg
    width="127"
    height="126"
    viewBox="0 0 127 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_1556_17760)">
      <rect x="9" y="8" width="110" height="110" rx="55" fill="#B1FFB5" />
      <rect
        x="9"
        y="8"
        width="110"
        height="110"
        rx="55"
        stroke="#D6FFD8"
        strokeOpacity="0.5"
        strokeWidth="15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.6247 53.2841V45.3675C70.6247 43.0967 68.7497 41.4092 66.6663 41.4092C66.208 41.4092 65.7288 41.4925 65.2705 41.6592L48.7288 47.9092C46.4163 48.7842 44.8955 50.9925 44.8955 53.4717V61.1175V61.1175V64.8258C44.8955 65.6175 45.7288 66.1175 46.4788 65.8675C47.6455 65.4716 48.8747 65.2633 50.1038 65.2633C56.4163 65.2633 61.5622 70.4091 61.5622 76.7216C61.5622 78.2216 61.1663 79.8675 60.5413 81.3258C60.208 82.0758 60.7288 82.9716 61.5413 82.9716H76.6455C80.958 82.9716 84.4788 79.4508 84.4788 75.1383V74.7425C84.4788 73.5966 83.5413 72.6591 82.3955 72.6591H80.583C78.583 72.6591 76.6663 71.43 76.1455 69.4925C75.7288 67.9091 76.2288 66.3675 77.2705 65.3675C78.0413 64.5758 79.1038 64.1175 80.2705 64.1175H82.3955C83.5413 64.1175 84.4788 63.18 84.4788 62.0341V61.1175C84.4788 56.805 80.958 53.2841 76.6455 53.2841H70.6247ZM67.4997 53.2841V45.3675C67.4997 44.805 66.9997 44.5342 66.6663 44.5342C66.5622 44.5342 66.458 44.555 66.3538 44.5967L49.833 50.8258C48.7288 51.2425 48.0205 52.2842 48.0205 53.4717V54.8675C49.333 53.8675 50.958 53.2841 52.7288 53.2841H67.4997ZM44.8955 70.2216C46.333 69.0757 48.1455 68.3882 50.1038 68.3882C54.708 68.3882 58.4372 72.1174 58.4372 76.7216C58.4372 78.2841 57.9997 79.7632 57.2288 81.0132C56.7913 81.7632 56.2288 82.4299 55.583 82.9716C54.1247 84.2841 52.208 85.0549 50.1038 85.0549C47.0622 85.0549 44.4163 83.4299 42.9788 81.0132C42.208 79.7632 41.7705 78.2841 41.7705 76.7216C41.7705 74.0966 42.9788 71.7424 44.8955 70.2216ZM49.9788 79.9299L54.4163 75.8257C55.0413 75.2424 55.083 74.2424 54.4997 73.6174C53.9163 72.9924 52.9163 72.9507 52.2913 73.5341L48.958 76.6174L47.958 75.6174C47.3538 75.0132 46.3538 75.0132 45.7497 75.6174C45.1455 76.2216 45.1455 77.2216 45.7497 77.8257L47.8122 79.8882C48.1247 80.2007 48.5205 80.3466 48.9163 80.3466C49.2913 80.3466 49.6872 80.2007 49.9788 79.9299ZM84.4791 67.3465V69.4299C84.4791 69.9924 84.0416 70.4507 83.4583 70.4715H80.4166C79.3125 70.4715 78.3125 69.659 78.2291 68.5757C78.1666 67.9299 78.4166 67.3257 78.8333 66.909C79.2083 66.5132 79.7291 66.3049 80.2916 66.3049H83.4375C84.0416 66.3257 84.4791 66.784 84.4791 67.3465ZM58.4372 63.7008H68.8538C69.708 63.7008 70.4163 62.9925 70.4163 62.1383C70.4163 61.2841 69.708 60.5758 68.8538 60.5758H58.4372C57.583 60.5758 56.8747 61.2841 56.8747 62.1383C56.8747 62.9925 57.583 63.7008 58.4372 63.7008Z"
        fill="#19A61E"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1556_17760"
        x="1.5"
        y="0.5"
        width="125"
        height="125"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="22" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.427536 0 0 0 0 0.883333 0 0 0 0 0.353333 0 0 0 0.09 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1556_17760"
        />
      </filter>
    </defs>
  </svg>
);

export const TOAST_SUCCESS_SVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9393 4.625C13.0774 3.125 10.9226 3.125 10.0607 4.625L2.30336 18.125C1.44143 19.625 2.51884 21.5 4.24268 21.5H19.7573C21.4812 21.5 22.5586 19.625 21.6966 18.125L13.9393 4.625ZM12 8.5C12.5523 8.5 13 8.94772 13 9.5V13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5V9.5C11 8.94772 11.4477 8.5 12 8.5ZM12 16.5C12.5523 16.5 13 16.9477 13 17.5C13 18.0523 12.5523 18.5 12 18.5C11.4477 18.5 11 18.0523 11 17.5C11 16.9477 11.4477 16.5 12 16.5Z"
      fill="#D84B4B"
    />
  </svg>
);

export const TOAST_ERROR_SVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9393 4.625C13.0774 3.125 10.9226 3.125 10.0607 4.625L2.30336 18.125C1.44143 19.625 2.51884 21.5 4.24268 21.5H19.7573C21.4812 21.5 22.5586 19.625 21.6966 18.125L13.9393 4.625ZM12 8.5C12.5523 8.5 13 8.94772 13 9.5V13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5V9.5C11 8.94772 11.4477 8.5 12 8.5ZM12 16.5C12.5523 16.5 13 16.9477 13 17.5C13 18.0523 12.5523 18.5 12 18.5C11.4477 18.5 11 18.0523 11 17.5C11 16.9477 11.4477 16.5 12 16.5Z"
      fill="#D84B4B"
    />
  </svg>
);

export const X_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 7L7 17M7 7L17 17"
      stroke="#250473"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CAKE_SVG = () => {
  const theme = useTheme();

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7477 11.25C11.547 11.25 10.9132 10.743 10.404 10.3358C9.97875 9.996 9.67125 9.75 8.9955 9.75C8.322 9.75 8.03025 9.98325 7.59 10.335C7.08075 10.743 6.447 11.25 5.24625 11.25C4.0455 11.25 3.41325 10.743 2.904 10.335C2.46375 9.98325 2.17275 9.75 1.5 9.75V13.5C1.5 14.3273 2.17275 15 3 15H15C15.8273 15 16.5 14.3273 16.5 13.5V9.75C15.8258 9.75 15.534 9.98325 15.093 10.3358C14.583 10.743 13.9493 11.25 12.7477 11.25ZM14.25 3.75H9.75V1.5H8.25V3.75H3.75C2.5095 3.75 1.5 4.7595 1.5 6V8.25C2.7 8.25 3.33225 8.757 3.8415 9.165C4.28175 9.51675 4.57275 9.75 5.24625 9.75C5.9205 9.75 6.2115 9.51675 6.6525 9.16425C7.16175 8.757 7.7955 8.25 8.9955 8.25C10.197 8.25 10.8308 8.757 11.3407 9.16425C11.7818 9.51675 12.0735 9.75 12.7477 9.75C13.4227 9.75 13.731 9.504 14.1562 9.16425C14.6655 8.757 15.2992 8.25 16.5 8.25V6C16.5 4.7595 15.4905 3.75 14.25 3.75Z"
        fill={theme.gray25}
      />
    </svg>
  );
};

export const LOGO_SVG = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 400 181"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <g transform="matrix(1,0,0,1,-88.5775,-146.69)">
      <g transform="matrix(1,0,0,1,210.5,111.249)">
        <g transform="matrix(0.69178,0,0,0.591177,145.105,102.546)">
          <path
            d="M0,78.174C-0.594,82.591 -1.104,87.229 -1.546,92.087C-1.987,96.945 -2.208,99.816 -2.208,100.699C-5.741,116.6 -10.455,131.913 -16.341,146.632C-24.885,168.427 -32.393,179.316 -38.866,179.316C-45.347,179.316 -48.583,165.038 -48.583,136.475C-48.583,122.934 -45.202,103.942 -38.424,79.5C-29.889,50.35 -20.91,35.774 -11.483,35.774C-2.65,35.774 1.767,42.399 1.767,55.649C1.767,62.427 1.173,69.934 0,78.174M-251.738,138.24C-251.738,107.324 -246.294,75.524 -235.397,42.841C-234.224,39.018 -232.457,37.1 -230.096,37.1C-225.977,37.1 -223.914,42.109 -223.914,52.115C-223.914,63.6 -226.715,79.058 -232.305,98.49C-238.488,120.871 -244.968,134.121 -251.738,138.24M188.148,55.208C186.084,55.208 184.318,57.416 182.847,61.833C175.781,88.042 170.482,107.476 166.948,120.132C157.818,151.347 149.281,166.949 141.33,166.949C132.787,166.949 128.523,152.968 128.523,124.99C128.523,115.274 129.696,101.734 132.056,84.358C134.996,65.518 136.472,54.476 136.472,51.233C136.763,49.466 137.722,46.526 139.343,42.399C140.958,38.279 141.773,35.774 141.773,34.892C141.773,30.184 137.5,27.824 128.965,27.824C123.954,27.237 121.014,30.771 120.131,38.424L120.573,55.208C120.573,58.451 119.834,64.779 118.364,74.199C116.301,86.566 115.273,92.901 115.273,93.191C112.03,116.157 107.17,135.302 100.698,150.608C99.221,154.438 96.722,160.18 93.19,167.833C89.36,175.195 85.239,178.875 80.823,178.875C75.226,178.875 72.431,172.4 72.431,159.441C72.431,128.524 74.488,101.141 78.614,77.291C79.201,75.234 80.084,71.847 81.264,67.132C82.437,63.309 83.031,59.921 83.031,56.975C83.031,54.035 81.851,51.309 79.497,48.803C77.138,46.306 74.488,45.049 71.548,45.049C68.014,45.049 65.51,46.229 64.039,48.583C63.133,50.008 62.311,54.02 61.576,60.612C61.052,61.954 60.547,63.523 60.066,65.365C54.173,89.513 47.99,111.299 41.517,130.733C31.801,160.476 24.292,175.341 18.992,175.341C12.809,174.167 9.42,163.126 8.833,142.216C8.833,133.093 11.332,108.504 16.343,68.458C22.815,18.108 26.349,-9.566 26.941,-14.576C29.592,-28.413 32.684,-44.83 36.217,-63.822C39.75,-82.813 42.104,-94.959 43.284,-100.259C44.457,-109.093 41.517,-113.509 34.451,-113.509C30.62,-113.509 28.115,-113.357 26.941,-113.067C23.409,-111.888 22.083,-107.326 22.968,-99.375C20.607,-80.826 17.516,-57.486 13.691,-29.371C9.861,-1.25 7.357,17.521 6.184,26.941C5.59,27.824 5.003,28.267 4.417,28.267C4.12,28.267 1.173,26.209 -4.417,22.083C-9.716,17.666 -14.285,15.458 -18.108,15.458C-29.302,15.458 -40.046,32.097 -50.35,65.365C-54.455,78.878 -57.629,91.73 -59.888,103.932C-61.687,110.061 -63.645,116.468 -65.803,123.225C-75.816,154.438 -84.352,170.041 -91.42,170.041C-99.667,170.041 -103.786,154.141 -103.786,122.341C-103.786,112.625 -102.316,93.93 -99.369,66.25C-98.196,55.945 -97.313,48.142 -96.719,42.841C-96.237,39.65 -95.835,37.464 -95.51,36.242C-97.988,30.748 -105.15,27.64 -117.036,26.941C-120.279,29.302 -122.337,36.657 -123.219,49.024C-124.4,67.285 -129.403,90.1 -138.236,117.483C-140.3,122.782 -143.391,133.976 -147.511,151.049C-149.872,158.709 -151.783,162.532 -153.253,162.532C-157.966,162.532 -160.32,151.933 -160.32,130.733C-160.32,121.899 -160.174,113.949 -159.878,106.882C-159.588,99.816 -159.436,91.865 -159.436,83.032C-159.436,79.209 -158.553,74.496 -156.786,68.899C-154.73,63.013 -153.695,59.183 -153.695,57.416C-153.695,52.115 -156.641,49.466 -162.528,49.466C-168.125,49.466 -171.803,51.826 -173.57,56.532C-174.419,58.44 -175.035,61.741 -175.424,66.39C-176.538,70.125 -177.829,74.774 -179.305,80.382C-196.971,147.516 -212.873,181.083 -227.005,181.083C-232.016,181.083 -237.019,177.99 -242.022,171.808C-247.033,165.334 -249.53,159.593 -249.53,154.583C-242.173,143.1 -235.991,131.768 -230.981,120.574C-218.324,93.487 -211.988,69.052 -211.988,47.257C-211.988,41.074 -214.569,35.774 -219.717,31.358C-224.873,26.941 -230.69,24.733 -237.164,24.733C-247.763,24.733 -255.866,40.785 -261.456,72.875C-262.211,77.063 -262.871,81.2 -263.477,85.309C-276.92,139.729 -289.05,166.949 -299.876,166.949C-306.942,166.949 -311.069,157.972 -312.242,140.007C-312.835,131.174 -313.126,114.688 -313.126,90.541C-313.126,67.574 -309.592,31.358 -302.526,-18.108L-281.325,-17.667C-271.905,-17.371 -258.953,-17.226 -242.459,-17.226C-236.869,-17.226 -228.478,-18.254 -217.283,-20.317C-203.744,-22.67 -196.38,-24.582 -195.2,-26.059L-195.2,-29.15C-203.151,-29.44 -211.694,-29.662 -220.817,-29.813C-229.947,-29.958 -237.456,-30.179 -243.342,-30.476C-249.235,-30.766 -253.797,-30.917 -257.033,-30.917C-263.513,-30.917 -270.063,-30.986 -276.688,-31.138C-283.313,-31.284 -288.322,-31.427 -291.704,-31.58C-295.093,-31.725 -297.522,-31.801 -298.992,-31.801C-296.638,-43.284 -294.873,-52.263 -293.692,-58.743L-293.692,-68.017C-301.641,-73.317 -307.536,-75.968 -311.359,-75.968C-313.718,-75.968 -315.334,-74.933 -316.217,-72.875L-314.009,-64.926C-314.305,-59.032 -315.044,-48.142 -316.217,-32.243C-352.137,-30.766 -373.634,-30.034 -380.7,-30.034C-384.234,-30.034 -386.001,-28.999 -386.001,-26.942C-386.001,-25.176 -384.379,-23.554 -381.141,-22.084C-377.015,-20.317 -373.924,-18.254 -371.867,-15.9L-361.709,-18.993C-336.975,-18.695 -322.11,-18.254 -317.1,-17.667C-324.76,55.649 -328.584,98.49 -328.584,110.858C-328.584,124.404 -326.968,138.097 -323.725,151.933C-318.721,171.959 -311.214,181.966 -301.2,181.966C-290.498,181.966 -279.16,165.209 -267.176,131.702C-267.179,132.26 -267.197,132.826 -267.197,133.382C-267.197,146.632 -264.257,159.15 -258.363,170.924C-250.71,184.768 -240.697,191.683 -228.331,191.683C-219.498,191.683 -211.699,187.41 -204.922,178.875C-194.393,164.354 -183.721,136.204 -172.906,94.428L-173.128,97.166C-174.011,107.766 -174.011,119.546 -173.128,132.5L-171.361,165.625C-169.008,177.99 -163.411,184.174 -154.577,184.174C-148.394,184.174 -143.833,177.847 -140.886,165.183C-131.17,126.612 -123.516,97.76 -117.92,78.615C-116.153,118.663 -114.241,143.983 -112.178,154.583C-108.057,175.493 -100.55,185.941 -89.653,185.941C-82.879,185.941 -74.339,172.486 -64.04,145.603C-64.04,145.651 -64.042,145.701 -64.042,145.75C-64.042,157.233 -62.122,166.949 -58.299,174.899C-53.296,186.086 -46.23,191.683 -37.1,191.683C-30.032,191.683 -22.966,185.058 -15.9,171.808C-13.25,167.101 -8.984,157.529 -3.091,143.1C-0.441,172.25 7.798,186.824 21.642,186.824C29.295,186.824 39.599,167.542 52.559,128.966C54.787,122.167 56.792,115.86 58.588,110.015C57.809,126.314 57.414,140.605 57.414,152.816C57.414,161.359 59.181,169.309 62.715,176.666C67.131,185.5 73.163,189.916 80.823,189.916C89.36,189.916 96.281,185.354 101.58,176.225C103.051,172.691 105.336,167.246 108.427,159.882C111.518,152.525 113.795,147.074 115.273,143.541C119.392,157.087 122.042,164.74 123.222,166.507C127.929,176.225 133.526,181.083 140.006,181.083C152.076,181.083 164.298,161.504 176.664,122.341C186.67,91.424 191.681,70.817 191.681,60.507C191.681,56.975 190.5,55.208 188.148,55.208"
            style={{ fill: 'rgb(44,42,110)', fillRule: 'nonzero' }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export const TAG_USER_SVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 2.5H6C4.34 2.5 3 3.83 3 5.47V16.38C3 18.02 4.34 19.36 6 19.36H6.76C7.55 19.36 8.32 19.67 8.88 20.23L10.59 21.92C11.37 22.69 12.63 22.69 13.41 21.92L15.12 20.23C15.68 19.67 16.45 19.36 17.24 19.36H18C19.66 19.36 21 18.02 21 16.38V5.47C21 3.83 19.66 2.5 18 2.5ZM12 6.05C13.08 6.05 13.95 6.93 13.95 8C13.95 9.06 13.11 9.91 12.07 9.95C12.03 9.95 11.97 9.95 11.92 9.95C10.87 9.91 10.04 9.06 10.04 8C10.05 6.93 10.92 6.05 12 6.05ZM14.75 15.19C13.24 16.2 10.76 16.2 9.25 15.19C7.92 14.31 7.92 12.85 9.25 11.96C10.77 10.95 13.25 10.95 14.75 11.96C16.08 12.85 16.08 14.3 14.75 15.19Z"
      fill="#7E7B8F"
    />
  </svg>
);

export const PLAY_BTN_SVG = ({ color = '#34079F', size = 28, onClick }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M13.9998 0.666504C6.63984 0.666504 0.666504 6.63984 0.666504 13.9998C0.666504 21.3598 6.63984 27.3332 13.9998 27.3332C21.3598 27.3332 27.3332 21.3598 27.3332 13.9998C27.3332 6.63984 21.3598 0.666504 13.9998 0.666504ZM17.5465 16.3065L15.8398 17.2932L14.1332 18.2798C11.9332 19.5465 10.1332 18.5065 10.1332 15.9732V13.9998V12.0265C10.1332 9.47984 11.9332 8.45317 14.1332 9.71984L15.8398 10.7065L17.5465 11.6932C19.7465 12.9598 19.7465 15.0398 17.5465 16.3065Z"
      fill={color}
    />
  </svg>
);

export const PAUSE_BTN_SVG = ({ onClick }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M13.9603 0.666504C6.60029 0.666504 0.626953 6.63984 0.626953 13.9998C0.626953 21.3598 6.60029 27.3332 13.9603 27.3332C21.3203 27.3332 27.2936 21.3598 27.2936 13.9998C27.2936 6.63984 21.3336 0.666504 13.9603 0.666504ZM12.2936 18.0398C12.2936 18.6798 12.027 18.9332 11.347 18.9332H9.61362C8.93362 18.9332 8.66695 18.6798 8.66695 18.0398V9.95984C8.66695 9.31984 8.93362 9.0665 9.61362 9.0665H11.3336C12.0136 9.0665 12.2803 9.31984 12.2803 9.95984V18.0398H12.2936ZM19.3336 18.0398C19.3336 18.6798 19.067 18.9332 18.387 18.9332H16.667C15.987 18.9332 15.7203 18.6798 15.7203 18.0398V9.95984C15.7203 9.31984 15.987 9.0665 16.667 9.0665H18.387C19.067 9.0665 19.3336 9.31984 19.3336 9.95984V18.0398Z"
      fill="#34079F"
    />
  </svg>
);

export const IMAGE_SVG = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M20.685 15.4176L17.8158 8.7076C17.2933 7.47927 16.5142 6.7826 15.625 6.73677C14.745 6.69093 13.8925 7.3051 13.2417 8.47843L11.5 11.6043C11.1333 12.2643 10.6108 12.6584 10.0425 12.7043C9.465 12.7593 8.8875 12.4568 8.42 11.8609L8.21834 11.6043C7.5675 10.7884 6.76084 10.3943 5.93584 10.4768C5.11084 10.5593 4.405 11.1276 3.9375 12.0534L2.35167 15.2159C1.78334 16.3618 1.83834 17.6909 2.5075 18.7726C3.17667 19.8543 4.34084 20.5051 5.615 20.5051H17.3117C18.54 20.5051 19.6858 19.8909 20.3642 18.8643C21.0608 17.8376 21.1708 16.5451 20.685 15.4176Z"
      fill="#7E7B8F"
    />
    <path
      d="M6.8891 7.68104C8.60027 7.68104 9.98744 6.29387 9.98744 4.58271C9.98744 2.87155 8.60027 1.48438 6.8891 1.48438C5.17794 1.48438 3.79077 2.87155 3.79077 4.58271C3.79077 6.29387 5.17794 7.68104 6.8891 7.68104Z"
      fill="#7E7B8F"
    />
  </svg>
);

export const STATUS_COMPLETED_SVG = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9167 8.4987C13.9167 11.7512 11.2524 14.4154 8 14.4154C4.74754 14.4154 2.08333 11.7512 2.08333 8.4987C2.08333 5.24624 4.74754 2.58203 8 2.58203C11.2524 2.58203 13.9167 5.24624 13.9167 8.4987Z"
      stroke="#42CD47"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16667 8.49995L7.05334 10.3866L10.8333 6.61328"
      stroke="#42CD47"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const STATUS_FAILED_SVG = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9167 8.4987C13.9167 11.7512 11.2524 14.4154 8 14.4154C4.74754 14.4154 2.08333 11.7512 2.08333 8.4987C2.08333 5.24624 4.74754 2.58203 8 2.58203C11.2524 2.58203 13.9167 5.24624 13.9167 8.4987Z"
      stroke="#D84B4B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.11333 10.3866L9.88666 6.61328"
      stroke="#D84B4B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.88666 10.3866L6.11333 6.61328"
      stroke="#D84B4B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const STATUS_PENDING_SVG = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 6.5V9.83333"
      stroke="#D58002"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.10042 14.0321C8.06757 14.0277 8.03405 14.0255 7.99999 14.0255H3.95999C2.96809 14.0255 2.45106 13.6774 2.23929 13.3166C2.0271 12.9551 1.97542 12.3324 2.45591 11.4658L4.53526 7.72033L4.53572 7.7195L6.49526 4.20033L6.4959 4.19918C7.01566 3.26186 7.59181 2.98047 7.99999 2.98047C8.40817 2.98047 8.98433 3.26186 9.50408 4.19918L9.50443 4.19981L11.4643 7.72617L11.4644 7.72647L13.5441 11.4725C13.5441 11.4726 13.5442 11.4727 13.5443 11.4728C14.024 12.3382 13.9715 12.9607 13.7585 13.3227C13.5457 13.6845 13.0278 14.0321 12.04 14.0321H8.10042Z"
      stroke="#D58002"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99634 11.832H8.00233"
      stroke="#D58002"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const STATUS_PROCESSING_SVG = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15.1654C11.6819 15.1654 14.6667 12.1806 14.6667 8.4987C14.6667 4.8168 11.6819 1.83203 8 1.83203C4.3181 1.83203 1.33333 4.8168 1.33333 8.4987C1.33333 12.1806 4.3181 15.1654 8 15.1654Z"
      stroke="#166DEF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.34001 10.1759C5.46001 10.3759 5.60667 10.5626 5.77334 10.7292C7.00001 11.9559 8.99334 11.9559 10.2267 10.7292C10.7267 10.2292 11.0133 9.59589 11.1067 8.94922"
      stroke="#166DEF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.89333 8.0555C4.98666 7.40216 5.27333 6.77547 5.77333 6.27547C7 5.0488 8.99333 5.0488 10.2267 6.27547C10.4 6.4488 10.54 6.63548 10.66 6.82881"
      stroke="#166DEF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.21333 11.9558V10.1758H6.99332"
      stroke="#166DEF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7867 5.04688V6.82686H9.00667"
      stroke="#166DEF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CROSS_SVG = ({ onClick }) => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3075 10.6084C23.698 10.2179 23.698 9.58472 23.3075 9.19419C22.9169 8.80367 22.2838 8.80367 21.8933 9.19419L16.0014 15.086L10.1081 9.19278C9.71763 8.80226 9.08446 8.80226 8.69394 9.19278C8.30341 9.58331 8.30341 10.2165 8.69394 10.607L14.5872 16.5003L8.69393 22.3935C8.30341 22.784 8.30341 23.4172 8.69393 23.8077C9.08446 24.1983 9.71762 24.1983 10.1081 23.8077L16.0014 17.9145L21.8933 23.8063C22.2838 24.1968 22.9169 24.1968 23.3075 23.8063C23.698 23.4158 23.698 22.7826 23.3075 22.3921L17.4156 16.5003L23.3075 10.6084Z"
      fill="#090A14"
    />
  </svg>
);

export const MODAL_STATUS_COMPLETED_SVG = () => (
  <svg
    width="103"
    height="115"
    viewBox="0 0 103 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3759_18957)">
      <rect x="15" y="4.5" width="74" height="95" rx="5.5" fill="#F2F6F9" />
      <rect
        x="26.0001"
        y="44.375"
        width="52.25"
        height="4.125"
        rx="2.0625"
        fill="#CBD5E1"
      />
      <rect
        x="26.0001"
        y="77.375"
        width="23.375"
        height="4.125"
        rx="2.0625"
        fill="#CBD5E1"
      />
      <rect
        x="26.0001"
        y="85.625"
        width="52.25"
        height="4.125"
        rx="2.0625"
        fill="#CBD5E1"
      />
      <rect
        x="54.8751"
        y="77.375"
        width="23.375"
        height="4.125"
        rx="2.0625"
        fill="#CBD5E1"
      />
      <rect
        x="26.0001"
        y="56.75"
        width="33"
        height="4.125"
        rx="2.0625"
        fill="#CBD5E1"
      />
      <rect
        x="26.0001"
        y="65"
        width="33"
        height="4.125"
        rx="2.0625"
        fill="#CBD5E1"
      />
      <rect
        x="65.8751"
        y="56.75"
        width="12.375"
        height="4.125"
        rx="2.0625"
        fill="#CBD5E1"
      />
      <rect
        x="65.8751"
        y="65"
        width="12.375"
        height="4.125"
        rx="2.0625"
        fill="#CBD5E1"
      />
      <circle cx="52.1251" cy="25.125" r="9.625" fill="#CBD5E1" />
    </g>
    <rect x="75" y="87" width="28" height="28" rx="14" fill="#34079F" />
    <path
      d="M82 101.357L87.0909 106.5L96 97.5"
      stroke="white"
      strokeWidth="2.0625"
      strokeLinecap="round"
    />
    <defs>
      <filter
        id="filter0_d_3759_18957"
        x="7"
        y="0.5"
        width="90"
        height="111"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.878889 0 0 0 0 0.900233 0 0 0 0 0.941667 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3759_18957"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3759_18957"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const MODAL_STATUS_FAILED_SVG = () => (
  <svg
    width="103"
    height="115"
    viewBox="0 0 103 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3759_19207)">
      <rect x="15" y="4.5" width="74" height="95" rx="5.5" fill="#FFE7E7" />
      <rect
        x="26.0002"
        y="44.375"
        width="52.25"
        height="4.125"
        rx="2.0625"
        fill="#D8BDBD"
      />
      <rect
        x="26.0002"
        y="77.375"
        width="23.375"
        height="4.125"
        rx="2.0625"
        fill="#D8BDBD"
      />
      <rect
        x="26.0002"
        y="85.625"
        width="52.25"
        height="4.125"
        rx="2.0625"
        fill="#D8BDBD"
      />
      <rect
        x="54.8752"
        y="77.375"
        width="23.375"
        height="4.125"
        rx="2.0625"
        fill="#D8BDBD"
      />
      <rect
        x="26.0002"
        y="56.75"
        width="33"
        height="4.125"
        rx="2.0625"
        fill="#D8BDBD"
      />
      <rect
        x="26.0002"
        y="65"
        width="33"
        height="4.125"
        rx="2.0625"
        fill="#D8BDBD"
      />
      <rect
        x="65.8752"
        y="56.75"
        width="12.375"
        height="4.125"
        rx="2.0625"
        fill="#D8BDBD"
      />
      <rect
        x="65.8752"
        y="65"
        width="12.375"
        height="4.125"
        rx="2.0625"
        fill="#D8BDBD"
      />
      <circle cx="52.1252" cy="25.125" r="9.625" fill="#D8BDBD" />
    </g>
    <rect x="75" y="87" width="28" height="28" rx="14" fill="#D84B4B" />
    <path
      d="M84 106.5L94 96.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M94 106.5L84 96.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_3759_19207"
        x="7"
        y="0.5"
        width="90"
        height="111"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.878889 0 0 0 0 0.900233 0 0 0 0 0.941667 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3759_19207"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3759_19207"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const NOT_FOUND_404_SVG = () => (
  <svg
    width="215"
    height="159"
    viewBox="0 0 215 159"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M86.5786 91.9239C91.3658 97.0794 97.6831 100.483 105.53 102.136C113.378 103.788 120.516 103.217 126.943 100.423C133.403 97.6362 138.919 92.7921 143.491 85.8913C148.101 78.9654 151.53 70.1649 153.778 59.4899C156.013 48.8785 156.41 39.506 154.971 31.3725C153.563 23.2458 150.462 16.6205 145.668 11.4969C140.875 6.37316 134.57 2.98845 126.754 1.34274C118.939 -0.302976 111.804 0.251905 105.351 3.00738C98.93 5.76954 93.4209 10.5818 88.8239 17.4442C84.2653 24.2815 80.8496 33.0184 78.5767 43.6549C76.3356 54.2982 75.9121 63.7149 77.3064 71.9052C78.7391 80.0705 81.8298 86.7434 86.5786 91.9239ZM125.008 81.2528C120.217 86.5149 114.771 88.5038 108.671 87.2193C104.605 86.363 101.375 84.2894 98.9823 80.9985C96.5962 77.6758 95.1517 73.191 94.6486 67.5441C94.1772 61.9039 94.777 55.1952 96.4478 47.418C98.928 35.7966 102.564 27.3548 107.355 22.0927C112.152 16.7988 117.585 14.7908 123.653 16.0685C127.688 16.9181 130.899 19.0043 133.285 22.327C135.678 25.6179 137.129 30.0709 137.639 35.686C138.148 41.3012 137.587 47.9848 135.955 55.7369C133.486 67.4603 129.837 75.9656 125.008 81.2528ZM3.15691 120.777L0.40332 106.676L29.1243 32.9374L34.4777 31.8919L40.8827 30.6412L51.2072 28.625L63.9297 93.7742L76.4529 91.3287L79.2998 105.907L66.7766 108.353L70.3236 126.516L53.403 129.82L49.856 111.657L3.15691 120.777ZM37.6333 52.1166L38.3981 51.9673L47.2002 97.0412L18.4734 102.651L18.324 101.886L37.6333 52.1166ZM130.249 122.84L134.129 109.006L192.932 56.0498L198.184 57.5226L204.468 59.2846L214.597 62.1248L196.674 126.039L208.96 129.484L204.949 143.787L192.663 140.342L187.667 158.161L171.067 153.506L176.064 135.687L130.249 122.84ZM191.911 77.007L192.662 77.2174L180.262 121.437L152.079 113.534L152.29 112.784L191.911 77.007Z"
      fill="#7A7AE4"
    />
  </svg>
);
